import { useTranslation } from 'react-i18next';

import { PlayTriangleIcon, IotDeviceAnalysisIcon } from 'icons';
import { colors } from 'styles/colors';

import { BtnPrimary } from '../../styles';
import {
  IdleWrap, IdleIconWrap, IdleContent, IdleTitleRow, IdleDesc, BetaBadge,
} from './styles';

interface IdleStateProps {
  onStartClick: () => void;
  isStarting: boolean;
}

export const IdleState = ({ onStartClick, isStarting }: IdleStateProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <IdleWrap>
      <IdleIconWrap>
        <IotDeviceAnalysisIcon color={colors.Blue300} size={34} />
      </IdleIconWrap>
      <IdleContent>
        <IdleTitleRow>
          {t('validacaoManutencao')}
          <BetaBadge>{t('beta')}</BetaBadge>
        </IdleTitleRow>
        <IdleDesc>{t('validacaoManutencaoDescricao')}</IdleDesc>
      </IdleContent>
      <BtnPrimary onClick={onStartClick} disabled={isStarting}>
        <PlayTriangleIcon color={colors.White} />
        {t('iniciarValidacaoManutencao')}
      </BtnPrimary>
    </IdleWrap>
  );
};
